











































































/*
  use ENUM for column names
  refactoring getInitObjectForThis change args to ENUM instead Column
  use foreach for statistic columns (ENUM help)
*/
import mixins from 'vue-typed-mixins'
import AbstractScriptRow from '../abstract'

export default mixins(AbstractScriptRow).extend({})
